import React from "react";
import { SnackbarProvider } from "notistack";

const SnackbarProviderWrapper = ({ children }) => (
  <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>
);

export default SnackbarProviderWrapper;
